import { __decorate, __metadata } from "tslib";
import { IsDateTimeZone } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsString } from 'class-validator';
import { StoreExposeGroup } from '../interface';
export class SquareDataDto {
}
__decorate([
    ApiProperty({ type: () => String, example: 'Test Business Name' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    IsString({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    __metadata("design:type", String)
], SquareDataDto.prototype, "businessName", void 0);
__decorate([
    ApiProperty({ type: () => String, example: 'US' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    IsString({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    __metadata("design:type", String)
], SquareDataDto.prototype, "country", void 0);
__decorate([
    ApiProperty({ type: () => String, example: 'USD' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    IsString({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    __metadata("design:type", String)
], SquareDataDto.prototype, "currency", void 0);
__decorate([
    ApiProperty({ type: () => String, example: 'America/New_York' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    IsDateTimeZone({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    __metadata("design:type", String)
], SquareDataDto.prototype, "timezone", void 0);
__decorate([
    ApiProperty({ type: () => String, example: 'Test Nickname' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    IsString({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    __metadata("design:type", String)
], SquareDataDto.prototype, "nickname", void 0);
__decorate([
    ApiProperty({ type: () => String, example: 'AQ6WEVCV0JPCH' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    IsString({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    __metadata("design:type", String)
], SquareDataDto.prototype, "locationId", void 0);
__decorate([
    ApiProperty({ type: () => String, example: '35ADFP18W8DHT' }),
    Expose({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    IsString({ groups: [StoreExposeGroup.MODEL, StoreExposeGroup.READ, StoreExposeGroup.CREATE] }),
    __metadata("design:type", String)
], SquareDataDto.prototype, "merchantId", void 0);
//# sourceMappingURL=SquareDataDto.js.map